import React from 'react'
import Shop from './Shop'
import Home from './Home'
import { Route, Routes } from 'react-router-dom'
import Contact from './Contact'
import Login from '../Admin/Login'
import Dashboard from '../Admin/Dashboard'
import FlashDeals from './FlashDeals'
import SearchResults from './SearchResults'

const Routing = () => {
  return (
    <Routes>
      <Route path='/' Component={Home} />
      <Route path='/shop' Component={Shop} />
      <Route path='/flashdeals' Component={FlashDeals} />
      <Route path='/contact' Component={Contact} />
      <Route path='/search' Component={SearchResults} />
      <Route path='/admin' Component={Login} />
      <Route path='/dashboard' Component={Dashboard} />   
    </Routes>
    
  )
}

export default Routing